// extracted by mini-css-extract-plugin
module.exports = {"component":"IconLink_component__ZAnNx","icon":"IconLink_icon__IbFTV"};